import React, { useState } from "react";
import { X } from "lucide-react";
import { api, getApiError } from "@/lib/api";

export default function QuoteDialog({ settings, language, onClose }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", service: "heating", message: "" });
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const copy = language === "en" ? {
    kicker: "DIRECT LINE / 01",
    title: "Let's make your space feel right.",
    intro: "Tell us what is happening and the best way to reach you.",
    name: "Name",
    email: "Email",
    phone: "Phone",
    service: "What do you need?",
    message: "A few details",
    namePlaceholder: "Your name",
    messagePlaceholder: "Tell us about the space or the issue",
    services: [["heating", "Heating"], ["cooling", "Cooling"], ["commercial", "Commercial HVAC"], ["maintenance", "Maintenance / air quality"]],
    submit: "Send request",
    success: "Your request is in. Protech will use the details here to follow up.",
  } : {
    kicker: "LÍNEA DIRECTA / 01",
    title: "Hagamos que tu espacio se sienta bien.",
    intro: "Cuéntanos qué sucede y cuál es la mejor forma de contactarte.",
    name: "Nombre",
    email: "Correo",
    phone: "Teléfono",
    service: "¿Qué necesitas?",
    message: "Algunos detalles",
    namePlaceholder: "Tu nombre",
    messagePlaceholder: "Cuéntanos sobre el espacio o el problema",
    services: [["heating", "Calefacción"], ["cooling", "Aire acondicionado"], ["commercial", "HVAC comercial"], ["maintenance", "Mantenimiento / calidad del aire"]],
    submit: "Enviar solicitud",
    success: "Recibimos tu solicitud. Protech usará estos datos para contactarte.",
  };
  const update = (field, value) => setForm((current) => ({ ...current, [field]: value }));

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    try {
      await api.post("/leads", { ...form, preferred_language: language });
      setSubmitted(true);
    } catch (requestError) {
      setError(getApiError(requestError));
    }
  };

  return (
    <div className="modal-backdrop" role="presentation" data-testid="quote-modal-backdrop">
      <div className="quote-dialog" role="dialog" aria-modal="true" aria-labelledby="quote-dialog-title" data-testid="quote-modal">
        <div className="dialog-header"><div><span className="eyebrow">{copy.kicker}</span><h2 className="dialog-title" id="quote-dialog-title">{copy.title}</h2><p className="dialog-copy">{copy.intro}</p></div><button className="dialog-close" type="button" onClick={onClose} aria-label="Close request form" data-testid="quote-modal-close-btn"><X /></button></div>
        {submitted ? <div className="form-success" data-testid="quote-success-message">{copy.success}</div> : <form onSubmit={submit} data-testid="quote-form"><div className="quote-form-grid"><div className="form-field"><label className="form-label" htmlFor="quote-name">{copy.name}</label><input className="text-input" id="quote-name" value={form.name} onChange={(event) => update("name", event.target.value)} placeholder={copy.namePlaceholder} required data-testid="quote-modal-name-input" /></div><div className="form-field"><label className="form-label" htmlFor="quote-email">{copy.email}</label><input className="text-input" id="quote-email" type="email" value={form.email} onChange={(event) => update("email", event.target.value)} placeholder="you@example.com" required data-testid="quote-modal-email-input" /></div><div className="form-field"><label className="form-label" htmlFor="quote-phone">{copy.phone}</label><input className="text-input" id="quote-phone" type="tel" value={form.phone} onChange={(event) => update("phone", event.target.value)} placeholder={settings.phone} required data-testid="quote-modal-phone-input" /></div><div className="form-field"><label className="form-label" htmlFor="quote-service">{copy.service}</label><select className="select-input" id="quote-service" value={form.service} onChange={(event) => update("service", event.target.value)} data-testid="quote-modal-service-select">{copy.services.map(([value, label]) => <option value={value} key={value}>{label}</option>)}</select></div><div className="form-field"><label className="form-label" htmlFor="quote-message">{copy.message}</label><textarea className="text-area" id="quote-message" value={form.message} onChange={(event) => update("message", event.target.value)} placeholder={copy.messagePlaceholder} data-testid="quote-modal-message-input" /></div></div>{error && <p className="form-error" data-testid="quote-error-message">{error}</p>}<button className="button dialog-submit" type="submit" data-testid="quote-modal-submit-btn">{copy.submit}</button></form>}
      </div>
    </div>
  );
}
